import React, { useEffect, useRef, useState } from "react"
import { concatStrings } from "../utilities"
import {
  addSubscriptionKey,
  deleteSubscriptionKey
} from "../../services/categorySubscriptions"
import ServiceError from "../../services/ServiceError"
import CAlert from "../elements/c_alert"
import CTooltipIcon from "./c_tooltip_icon"

const MESSAGE_API_ERROR = "something went wrong!"
const IS_SUBSCRIBED_CLASS = "is-subscribed"
const IS_UNSUBSCRIBED_CLASS = "is-unsubscribed"

const CSubscribeIcon = props => {
  const [unauthorized, setUnauthorized] = useState(null)
  const [networkError, setNetworkError] = useState(null)
  const [keySubscribed, setKeySubscribed] = useState(null)
  const [keySubscribedClass, setKeySubscribedClass] = useState("")
  const [subscriptionKeys, setSubscriptionKeys] = useState([])
  const isInitialRef = useRef(null)

  const subscriptionKey = props.uid.toString()

  const init = () => {
    if (!props.subscriptionKeysData.error) {
      const keys = props.subscriptionKeysData.keys
      const isSubscribed = keys.indexOf(subscriptionKey) !== -1
      setSubscriptionKeys(keys)
      setKeySubscribed(isSubscribed)
      setKeySubscribedClass(
        isSubscribed ? IS_SUBSCRIBED_CLASS : IS_UNSUBSCRIBED_CLASS
      )
    } else {
      handleErrors(props.subscriptionKeysData.error)
    }
  }

  const handleSubscription = async key => {
    isInitialRef.current = false
    const subscriptionKey = key.toString()
    const isKeySubscribed = subscriptionKeys.indexOf(subscriptionKey) !== -1
    try {
      setKeySubscribed(null)
      if (!isKeySubscribed) {
        setSubscriptionKeys(await addSubscriptionKey(subscriptionKey))
        setKeySubscribed(true)
        setKeySubscribedClass(IS_SUBSCRIBED_CLASS)
      } else {
        setSubscriptionKeys(await deleteSubscriptionKey(subscriptionKey))
        setKeySubscribed(false)
        setKeySubscribedClass(IS_UNSUBSCRIBED_CLASS)
      }
    } catch (err) {
      handleErrors(err)
    }
  }

  const handleErrors = err => {
    if (err.statusCode === ServiceError.STATUS_UNAUTHORIZED) {
      setUnauthorized(true)
    } else {
      setUnauthorized(false)
      setNetworkError(MESSAGE_API_ERROR)
    }
  }

  useEffect(() => {
    if (props.subscriptionKeysData) {
      init()
    }
    return () => (isInitialRef.current = true)
  }, [props.subscriptionKeysData])

  return !unauthorized && !networkError ? (
    <>
      <div
        className={concatStrings(
          `c-SubscribeIcon c-SubscribeIcon--small c-SubscribeIcon--tooltip
        ${keySubscribedClass}
        ${keySubscribed == null ? "is-disabled" : ""}`,
          props.add_class
        )}
        role="button"
        tabIndex="0"
        onClick={() => handleSubscription(subscriptionKey)}
      >
        <CTooltipIcon
          tooltip="Kategorie abonnieren"
          icon="add"
          small={true}
          add_class="c-SubscribeIcon-icon c-SubscribeIcon-icon--subscribe"
        />
        <CTooltipIcon
          tooltip="Kategorie deabonnieren"
          icon="check-circle"
          small={true}
          add_class="c-SubscribeIcon-icon c-SubscribeIcon-icon--unsubscribe"
        />
      </div>
      {!unauthorized && isInitialRef.current === false && keySubscribed != null && (
        <CAlert
          type={keySubscribed ? "success" : ""}
          message={`Sie haben die Kategorie ${props.title} ${keySubscribed ? 'abonniert' : 'deabonniert'}.`}
        />
      )}
      {!unauthorized && networkError && (
        <CAlert
          type="error"
          message={MESSAGE_API_ERROR}
        />
      )}
    </>
  ) : null
}

export default CSubscribeIcon
